import React, { useEffect } from 'react';
import styles from '../../styles/Messenger.module.css';
import moment from 'moment';

//let data: any;
const ItemMessages = (props) => {

    let allMessages = props.data // getting messages

    let showAllMessages = (
        <p>Ni Sporočil</p>
    );
    
    // mobile app!! or if width < 450? 
    // const checkAuthor = (each, i) => {
    //     if (each.author === "Zdravnik") {
    //         return styles.EachTopRight
    //     } else if (each.author === "Aplikacija") {
    //         return styles.EachTopMiddle
    //     } else {
    //         return styles.EachTopLeft
    //     }
    // }
    const checkDate = (each) => {
        let today = moment().date() //.format("YYYY/MM/DD");
        let tod = (today, "YYYY/MM/DD")
        if (each.date === tod) {
            return "today"
        } else {
            return each.date
        }
        
    }
    
    const checkTopLineAuthor = (each, i) => {
        if (i > 0) {
           if (allMessages[i - 1].author === each.author && allMessages[i - 1].date === each.date) {
               return (
                   <p>{each.message}</p>
               )
           } else if (allMessages[i - 1].author === each.author && allMessages[i - 1].date !== each.date) {
               return (
                <React.Fragment>
                    <p className={styles.DateLine}><span>{checkDate(each)}</span></p>
                    <div className={styles.EachTop}>
                        <h4>{each.author}</h4>
                        <p>{each.time}</p>
                    </div>
                    <p>{each.message}</p>
                </React.Fragment>
               )
            } else if (allMessages[i - 1].author !== each.author && allMessages[i - 1].date === each.date) {
                return (
                    <React.Fragment>
                        <div className={styles.EachTop}>
                            <h4>{each.author}</h4>
                            <p>{each.time}</p>
                        </div>
                        <p>{each.message}</p>
                    </React.Fragment>
                )
            } else if (allMessages[i - 1].author !== each.author && allMessages[i - 1].date !== each.date) {
                return (
                    <React.Fragment>
                        <p className={styles.DateLine}><span>{checkDate(each)}</span></p>
                        <div className={styles.EachTop}>
                            <h4>{each.author}</h4>
                            <p>{each.time}</p>
                        </div>
                        <p>{each.message}</p>
                    </React.Fragment>
                )
            }
        } else if (i === 0) {
            return (
                <React.Fragment>
                    <p className={styles.DateLine}><span>{checkDate(each)}</span></p>
                    <div className={styles.EachTop}>
                        <h4>{each.author}</h4>
                        <p>{each.time}</p>
                        
                    </div>
                    <p>{each.message}</p>
                </React.Fragment>
            )
        }
    }
    //{checkAuthor(each)}
    if (allMessages) {
        showAllMessages = (
            allMessages.map((each, i) => (
                <div
                    className={styles.EachMessage}
                    key={each.id}>

                    {checkTopLineAuthor(each, i)}
                    
                </div>
            ))
        )
    }
    
    
    useEffect(() => {
        let element = document.getElementById("box");
        //element.scrollIntoView();
        element.scrollTop = element.scrollHeight;
        //element.scrollIntoView({ behavior: 'smooth', block: 'end' });
    })

    return  (
        <div className={styles.Messenger} id="box">
            { showAllMessages }
        </div>
    ) 
}

export default ItemMessages;
